<template>
	<view class="order">
		<view class="container_h" :style="{height: 'calc(' + (navHeight + statusbarHeight) + 'px' + ' + 224rpx)'}">
			<view class="container_box">
				<view class="container_status" :style="{height: statusbarHeight + 'px'}"></view>
				<view class="container_head" :style="{height: navHeight + 'px'}">
					<uni-icons type="back" size="20" color="#fff" @click="go"></uni-icons>
					<text>订单详情</text>
					<text></text>
				</view>
			</view>
			<view class="container_h_info" :style="{ paddingTop: 'calc(' + (navHeight + statusbarHeight) + 'px' + ' + 20rpx)' }">
				<view class="container_h_info_left">
					<text>待支付</text>
					<text>订单将在29:39秒后自动取消</text>
				</view>
				<image src="@/static/icon/ic_baoguo@2x.png" mode="widthFix"></image>
			</view>
		</view>
		<view class="order_info">
			<view class="order_info_item">
				<image src="@/static/icon/ic_yunshu@2x.png" mode="widthFix"></image>
				<view class="order_info_box">
					<view class="order_info_box_top jus">
						<text>订单已确认，商家正在备货</text>
						<uni-icons type="forward" size="20" color="#999999"></uni-icons>
					</view>
					<text class="order_info_box_text hui">2022-12-30 15:29</text>
				</view>
			</view>
			<view class="order_info_item">
				<image src="@/static/icon/huodong_ic_didian@2x.png" mode="widthFix"></image>
				<view class="order_info_box">
					<view class="order_info_box_top">
						<text>刘美女</text>
						<text>17839484470</text>
					</view>
					<text class="order_info_box_text">上海 上海市 青浦区 夏阳街道华科路新青浦家园144号楼101</text>
				</view>
			</view>
		</view>
		<view class="order_shop">
			<view class="order_shop_info">
				<view class="order_shop_info_img">
					<image src="@/static/uni.png" mode="widthFix"></image>
				</view>
				<view class="order_shop_info_right">
					<view class="order_shop_info_right_top">
						<view class="title">清澄白河马克杯-节日版</view>
						<view class="price">
							<text>¥</text>
							<text>79</text>
							<text>.98</text>
						</view>
					</view>
					<view class="order_shop_info_right_bottom">
						<text>白色</text>
						<text>x1</text>
					</view>
				</view>
			</view>
			<view class="order_shop_list">
				<view class="order_shop_list_item">
					<text class="label">优惠券</text>
					<text class="price">-￥5</text>
				</view>
				<view class="order_shop_list_item">
					<text class="label">需付款</text>
					<text class="price_h">
						<text>￥</text>
						<text>74</text>
						<text>.98</text>
					</text>
				</view>
				<view class="order_shop_list_item">
					<text class="label">订单留言</text>
					<input
						type="text"
						placeholder="选填，建议与商家协商一致"
						placeholder-style="text-align: right;color: #999999;font-weight: 500;font-size: 28rpx;"
					/>
				</view>
				<view class="order_shop_list_x"></view>
				<view class="order_shop_list_item nottop">
					<text class="label">订单编号</text>
					<view class="copy">
						<text>204802845195194980</text>
						<text>|</text>
						<text>复制</text>
					</view>
				</view>
				<view class="order_shop_list_item">
					<text class="label">下单时间</text>
					<text class="time">2022-12-29 10:22</text>
				</view>
			</view>
		</view>
		<view class="order_list">
			<view class="order_list_head">
				<image src="@/static/icon/title_left@2x.png" mode="widthFix"></image>
				<text>你可能还喜欢</text>
				<image src="@/static/icon/title_right@2x.png" mode="widthFix"></image>
			</view>
			<view class="order_list_box">
				<view class="fun_list_item" v-for="(item, index) in 3" :key="index">
					<view class="fun_list_item_img">
						<image src="@/static/uni.png" mode="heightFix"></image>
					</view>
					<view class="fun_list_item_info">
						<view class="fun_list_item_info_top">
							<text>飞盘之后，新中产又被围炉煮茶割韭菜？飞盘之后，新中产又</text>
						</view>
						<view class="fun_list_item_info_bottom">
							<view class="fun_list_item_info_bottom_left">
								<text>¥</text>
								<text>179</text>
							</view>
							<view class="fun_list_item_info_bottom_right">
								<text>已售619份</text>
							</view>
						</view>
					</view>
				</view>
			</view>
		</view>
		<view class="order_footer">
			<view class="order_footer_left" @click="openOrder">更多</view>
			<view class="order_footer_right">
				<!-- 待支付 -->
				<view class="order_footer_right_btn">联系客服</view>
				<view class="order_footer_right_btn">修改地址</view>
				<view class="order_footer_right_btn1">去支付</view>
				
				<!-- 待发货 -->
				<!-- <view class="order_footer_right_btn">联系客服</view>
				<view class="order_footer_right_btn">修改地址</view>
				<view class="order_footer_right_btn1">催发货</view> -->
				
				<!-- 交易关闭 -->
				<!-- <view class="order_footer_right_btn">删除订单</view>
				<view class="order_footer_right_btn1">加购物车</view> -->
				
				<!-- 待收货 -->
				<!-- <view class="order_footer_right_btn">联系客服</view>
				<view class="order_footer_right_btn">查看物流</view>
				<view class="order_footer_right_btn1">确认收货</view> -->
			</view>
		</view>
		<view class="order_zw"></view>
		<!-- 退款原因 -->
		<uni-popup ref="popup1" background-color="#fff">
			<view class="popup1">
				<view class="popup_head">
					<text></text>
					<text>退款原因</text>
					<uni-icons type="closeempty" @click="close" size="20" color="#999999"></uni-icons>
				</view>
				<view class="popup_list">
					<view class="popup_list_item" v-for="(item, index) in cates" :key="index" @click="changeCate(index)">
						<text>{{item.name}}</text>
						<radio color="#D20A0A" :value="item.id" :checked="index === current" />
					</view>
				</view>
				<view class="popup_footer">
					<view class="popup_footer_btn">
						<view class="popup_footer_btn_right" @click="define">确定</view>
					</view>
				</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				cates: [
					{ name: '价格有点贵', id: 1 },
					{ name: '规格/款式/数量拍错', id: 2 },
					{ name: '暂时不需要', id: 3 },
					{ name: '其他', id: 4 }
				],
				from: {
					name: '',
					val: ''
				},
				current: 0
			}
		},
		computed: {
			...mapState(['statusbarHeight', 'navHeight'])
		},
		methods: {
			go() {
				uni.navigateBack({ delta: 1 });
			},
			openOrder() {
				this.$refs.popup1.open('bottom')
			},
			close() {
				this.$refs.popup1.close()
			},
			changeCate(index) {
				this.current = index
			},
			define() {
				this.from.name = this.cates[this.current].name
				this.from.val = this.cates[this.current].id
				this.$refs.popup.close()
			},
		}
	}
</script>

<style lang="scss" scoped>
	.order {
		width: 100%;
		.container_h {
			width: 100%;
			background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
			.container_box {
				width: 100%;
				position: fixed;
				left: 0;
				top: 0;
				z-index: 9;
				.container_status {
					width: 100%;
				}
				.container_head {
					width: 100%;
					padding: 0 32rpx;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					justify-content: space-between;
					background-color: rgba(0, 0, 0, 0);
					text {
						font-size: 34rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #FFFFFF;
						margin-right: 20rpx;
					}
				}
			}
			.container_h_info {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				// margin-top: 20rpx;
				.container_h_info_left {
					display: flex;
					flex-direction: column;
					margin-left: 32rpx;
					text {
						&:nth-child(1) {
							font-size: 40rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #FFFFFF;
						}
						&:nth-child(2) {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #FFFFFF;
							margin-top: 20rpx;
						}
					}
				}
				image {
					margin-right: 80rpx;
					width: 150rpx;
					height: 150rpx;
				}
			}
		}
		.order_info {
			width: 100%;
			padding: 28rpx 34rpx;
			background: #FFFFFF;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			.order_info_item {
				display: flex;
				align-items: center;
				margin-top: 24rpx;
				padding-bottom: 24rpx;
				border-bottom: 2rpx solid #F4F5F4;
				&:nth-child(2) {
					border: none !important;
					padding-bottom: 0 !important;
				}
				&:nth-child(1) {
					margin-top: 0 !important;
				}
				image {
					width: 25rpx;
					height: 30rpx;
					flex-shrink: 0;
					margin-right: 22rpx;
				}
				.order_info_box {
					flex: 1;
					display: flex;
					flex-direction: column;
					.jus {
						display: flex !important;
						align-items: center !important;
						justify-content: space-between !important;
					}
					.order_info_box_top {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #333333;
							}
							&:nth-child(2) {
								font-size: 24rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #999999;
							}
						}
					}
					.hui {
						color: #999999 !important;
					}
					.order_info_box_text {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						margin-top: 16rpx;
					}
				}
			}
		}
		.order_shop {
			width: 100%;
			padding: 40rpx 32rpx 28rpx 32rpx;
			background-color: #FFFFFF;
			margin-top: 16rpx;
			box-sizing: border-box;
			.order_shop_info {
				display: flex;
				align-items: flex-start;
				.order_shop_info_img {
					flex-shrink: 0;
					width: 180rpx;
					height: 180rpx;
					background: #FFFFFF;
					border-radius: 12rpx;
					border: 2rpx solid #F5F5F5;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 20rpx;
					image {
						width: 160rpx;
						height: 160rpx;
					}
				}
				.order_shop_info_right {
					flex: 1;
					display: flex;
					flex-direction: column;
					.order_shop_info_right_top {
						display: flex;
						align-items: center;
						justify-content: space-between;
						.title {
							width: 320rpx;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.price {
							display: flex;
							align-items: center;
							text {
								&:nth-child(1) {
									font-size: 20rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-top: 8rpx;
								}
								&:nth-child(2) {
									font-size: 28rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
								}
								&:nth-child(3) {
									font-size: 20rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-top: 8rpx;
								}
							}
						}
					}
					.order_shop_info_right_bottom {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 16rpx;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
				}
			}
			.order_shop_list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 42rpx;
				.nottop {
					margin-top: 0 !important;
				}
				.order_shop_list_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 32rpx;
					&:first-child {
						margin-top: 0 !important;
					}
					.label {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
					.time {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
					.price {
						font-size: 24rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #D20A0A;
					}
					.copy {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #999999;
							}
							&:nth-child(2) {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #999999;
								margin: 0 8rpx;
							}
							&:nth-child(3) {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #333333;
							}
						}
					}
					.price_h {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 20rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
								margin-top: 8rpx;
							}
							&:nth-child(2) {
								font-size: 28rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
							}
							&:nth-child(3) {
								font-size: 20rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
								margin-top: 8rpx;
							}
						}
					}
					input {
						width: 336rpx;
						text-align: right;
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #000000;
					}
				}
				.order_shop_list_x {
					width: 100%;
					height: 0rpx;
					margin: 24rpx 0;
					border: 2rpx solid #F4F5F4;
				}
			}
		}
		.order_footer {
			width: 100%;
			background-color: #FFFFFF;
			box-sizing: border-box;
			position: fixed;
			bottom: 0;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 20rpx 32rpx calc(20rpx + env(safe-area-inset-bottom)) 32rpx;
			.order_footer_left {
				font-size: 28rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
			.order_footer_right {
				display: flex;
				align-items: center;
				.order_footer_right_btn {
					width: 144rpx;
					height: 52rpx;
					line-height: 52rpx;
					text-align: center;
					border-radius: 30rpx;
					border: 2rpx solid #D9D9D9;
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
					margin-right: 16rpx;
				}
				.order_footer_right_btn1 {
					width: 144rpx;
					height: 52rpx;
					line-height: 52rpx;
					text-align: center;
					background: #FFFFFF;
					border-radius: 30rpx;
					border: 2rpx solid #D20A0A;
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #D20A0A;
				}
			}
		}
		.order_list {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 32rpx;
			.order_list_head {
				display: flex;
				align-items: center;
				justify-content: center;
				image {
					width: 33rpx;
					height: 8rpx;
				}
				text {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					margin: 0 16rpx;
				}
			}
			.order_list_box {
				margin-top: 32rpx;
				width: 100%;
				padding: 0 32rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: space-between;
				.fun_list_item {
					width: 332rpx;
					height: 580rpx;
					border-radius: 20rpx;
					background-color: white;
					overflow: hidden;
					margin-bottom: 16rpx;
					.fun_list_item_img {
						width: 100%;
						height: 420rpx;
						display: flex;
						align-items: center;
						justify-content: center;
						overflow: hidden;
						image {
							height: 100%;
						}
					}
					.fun_list_item_info {
						width: 100%;
						padding: 16rpx 12rpx 24rpx 12rpx;
						box-sizing: border-box;
						display: flex;
						flex-direction: column;
						.fun_list_item_info_top {
							width: 100%;
							-webkit-line-clamp: 2;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							text-overflow: ellipsis;
							overflow: hidden;
							text {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #333333;
							}
						}
						.fun_list_item_info_bottom {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-top: 15rpx;
							.fun_list_item_info_bottom_left {
								display: flex;
								align-items: center;
								text {
									&:first-child {
										font-size: 20rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #D20A0A;
										margin-top: 11rpx;
									}
									&:last-child {
										font-size: 32rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #D20A0A;
									}
								}
							}
							.fun_list_item_info_bottom_right {
								display: flex;
								align-items: center;
								text {
									font-size: 24rpx;
									font-family: PingFang SC-Medium, PingFang SC;
									font-weight: 500;
									color: #999999;
								}
							}
						}
					}
				}
			}
		}
		.order_zw {
			width: 100%;
			height: calc(92rpx + env(safe-area-inset-bottom));
		}
		.popup1 {
			padding: 48rpx 32rpx 0 32rpx;
			.popup_head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}
			.popup_list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 68rpx;
				.popup_list_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 62rpx;
					&:last-child {
						margin-bottom: 0 !important;
					}
					text {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
				}
			}
			.popup_footer {
				padding: 0 24rpx;
				margin-top: 112rpx;
				.popup_footer_btn {
					width: 100%;
					height: 72rpx;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 36rpx;
					overflow: hidden;
					display: flex;
					align-items: center;
					.popup_footer_btn_right {
						flex: 1;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						background: #D20A0A;
						font-size: 32rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #FFFFFF;
					}
				}
			}
		}
	}
</style>